import { render, staticRenderFns } from "./BaseRadioButton.vue?vue&type=template&id=fa530d6c&scoped=true"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioButton.vue?vue&type=style&index=0&id=fa530d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa530d6c",
  null
  
)

export default component.exports